/* tslint:disable */
/* eslint-disable */
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.13.2.0 (NJsonSchema v10.5.2.0 (Newtonsoft.Json v11.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

import {optionsTransformer} from '@sekoia/shared/requests/nswagBaseClients/baseClient';
import * as moment from 'moment';

export class BaseClient {
  getBaseUrl(_: string, parsedBaseUrl: string | undefined): string {
    if (parsedBaseUrl) {
      return parsedBaseUrl;
    }

    if (!process.env.DASHBOARDS_SERVICE_URL) {
      throw new Error('DASHBOARDS_SERVICE_URL must be set in environment');
    }

    return process.env.DASHBOARDS_SERVICE_URL;
  }
  
  async transformOptions(options: RequestInit) : Promise<RequestInit> {
    return optionsTransformer.addDefaultHeaders(options);
  }
}

export class WidgetClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : <any>window;
        this.baseUrl = this.getBaseUrl("https://services-dashboards-dev.sekoia.one", baseUrl);
    }

    getWidgets(): Promise<WidgetResponse[]> {
        let url_ = this.baseUrl + "/api/widgets";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetWidgets(_response);
        });
    }

    protected processGetWidgets(response: Response): Promise<WidgetResponse[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(WidgetResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<WidgetResponse[]>(<any>null);
    }

    updateWidget(widgetId: string, request: UpdateWidgetRequest): Promise<void> {
        let url_ = this.baseUrl + "/api/widgets/{widgetId}";
        if (widgetId === undefined || widgetId === null)
            throw new Error("The parameter 'widgetId' must be defined.");
        url_ = url_.replace("{widgetId}", encodeURIComponent("" + widgetId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateWidget(_response);
        });
    }

    protected processUpdateWidget(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }
}

export class DashboardClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : <any>window;
        this.baseUrl = this.getBaseUrl("https://services-dashboards-dev.sekoia.one", baseUrl);
    }

    getDashboards(): Promise<DashboardResponse[]> {
        let url_ = this.baseUrl + "/api/dashboards";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetDashboards(_response);
        });
    }

    protected processGetDashboards(response: Response): Promise<DashboardResponse[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DashboardResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DashboardResponse[]>(<any>null);
    }

    createDashboard(request: CreateDashboardRequest): Promise<CreateDashboardResponse> {
        let url_ = this.baseUrl + "/api/dashboards";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateDashboard(_response);
        });
    }

    protected processCreateDashboard(response: Response): Promise<CreateDashboardResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = CreateDashboardResponse.fromJS(resultData201);
            return result201;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CreateDashboardResponse>(<any>null);
    }

    updateDashboard(id: string, request: UpdateDashboardRequest): Promise<void> {
        let url_ = this.baseUrl + "/api/dashboards/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateDashboard(_response);
        });
    }

    protected processUpdateDashboard(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    deleteDashboard(id: string): Promise<void> {
        let url_ = this.baseUrl + "/api/dashboards/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeleteDashboard(_response);
        });
    }

    protected processDeleteDashboard(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    updateDashboardsOrder(request: UpdateDashboardsOrderRequest): Promise<void> {
        let url_ = this.baseUrl + "/api/dashboards/order";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateDashboardsOrder(_response);
        });
    }

    protected processUpdateDashboardsOrder(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    createAndAddWidgetToDashboard(request: CreateWidgetRequest, dashboardId: string): Promise<WidgetCreatedIdResponse> {
        let url_ = this.baseUrl + "/api/dashboards/{dashboardId}/widgets";
        if (dashboardId === undefined || dashboardId === null)
            throw new Error("The parameter 'dashboardId' must be defined.");
        url_ = url_.replace("{dashboardId}", encodeURIComponent("" + dashboardId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateAndAddWidgetToDashboard(_response);
        });
    }

    protected processCreateAndAddWidgetToDashboard(response: Response): Promise<WidgetCreatedIdResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = WidgetCreatedIdResponse.fromJS(resultData201);
            return result201;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<WidgetCreatedIdResponse>(<any>null);
    }

    removeWidgetFromDashboard(dashboardId: string, widgetId: string): Promise<void> {
        let url_ = this.baseUrl + "/api/dashboards/{dashboardId}/widgets/{widgetId}";
        if (dashboardId === undefined || dashboardId === null)
            throw new Error("The parameter 'dashboardId' must be defined.");
        url_ = url_.replace("{dashboardId}", encodeURIComponent("" + dashboardId));
        if (widgetId === undefined || widgetId === null)
            throw new Error("The parameter 'widgetId' must be defined.");
        url_ = url_.replace("{widgetId}", encodeURIComponent("" + widgetId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processRemoveWidgetFromDashboard(_response);
        });
    }

    protected processRemoveWidgetFromDashboard(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }
}

export class WidgetResponse implements IWidgetResponse {
    id!: string;
    dataSource!: DataSource;
    displayType!: DisplayType;

    constructor(data?: IWidgetResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.dataSource = _data["dataSource"];
            this.displayType = _data["displayType"];
        }
    }

    static fromJS(data: any): WidgetResponse {
        data = typeof data === 'object' ? data : {};
        let result = new WidgetResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["dataSource"] = this.dataSource;
        data["displayType"] = this.displayType;
        return data; 
    }
}

export interface IWidgetResponse {
    id: string;
    dataSource: DataSource;
    displayType: DisplayType;
}

export enum DataSource {
    Unknown = "Unknown",
    TaskStatus = "TaskStatus",
    TaskCompletion = "TaskCompletion",
    TaskProfessions = "TaskProfessions",
    ResidentStatus = "ResidentStatus",
    ResidentLengthOfStay = "ResidentLengthOfStay",
    PlanStatus = "PlanStatus",
    TaskWorkLoad = "TaskWorkLoad",
    FormRegistrationsWithFilters = "FormRegistrationsWithFilters",
    FormWithMissingRegistrations = "FormWithMissingRegistrations",
}

export enum DisplayType {
    Unknown = "Unknown",
    HorizontalBarChart = "HorizontalBarChart",
    VerticalBarChart = "VerticalBarChart",
    ListChart = "ListChart",
}

export class ProblemDetails implements IProblemDetails {
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;
    extensions!: { [key: string]: any; };

    constructor(data?: IProblemDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.extensions = {};
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["type"];
            this.title = _data["title"];
            this.status = _data["status"];
            this.detail = _data["detail"];
            this.instance = _data["instance"];
            if (_data["extensions"]) {
                this.extensions = {} as any;
                for (let key in _data["extensions"]) {
                    if (_data["extensions"].hasOwnProperty(key))
                        (<any>this.extensions)![key] = _data["extensions"][key];
                }
            }
        }
    }

    static fromJS(data: any): ProblemDetails {
        data = typeof data === 'object' ? data : {};
        let result = new ProblemDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["title"] = this.title;
        data["status"] = this.status;
        data["detail"] = this.detail;
        data["instance"] = this.instance;
        if (this.extensions) {
            data["extensions"] = {};
            for (let key in this.extensions) {
                if (this.extensions.hasOwnProperty(key))
                    (<any>data["extensions"])[key] = this.extensions[key];
            }
        }
        return data; 
    }
}

export interface IProblemDetails {
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;
    extensions: { [key: string]: any; };
}

export class UpdateWidgetRequest implements IUpdateWidgetRequest {
    filter!: FilterRequest;
    displayProperties!: WidgetDisplayPropertyRequest[];

    constructor(data?: IUpdateWidgetRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.displayProperties = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.filter = _data["filter"] ? FilterRequest.fromJS(_data["filter"]) : <any>undefined;
            if (Array.isArray(_data["displayProperties"])) {
                this.displayProperties = [] as any;
                for (let item of _data["displayProperties"])
                    this.displayProperties!.push(WidgetDisplayPropertyRequest.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdateWidgetRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateWidgetRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["filter"] = this.filter ? this.filter.toJSON() : <any>undefined;
        if (Array.isArray(this.displayProperties)) {
            data["displayProperties"] = [];
            for (let item of this.displayProperties)
                data["displayProperties"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IUpdateWidgetRequest {
    filter: FilterRequest;
    displayProperties: WidgetDisplayPropertyRequest[];
}

export abstract class FilterRequest implements IFilterRequest {

    protected _discriminator: string;

    constructor(data?: IFilterRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        this._discriminator = "FilterRequest";
    }

    init(_data?: any) {
    }

    static fromJS(data: any): FilterRequest {
        data = typeof data === 'object' ? data : {};
        if (data["discriminator"] === "FormFilterRequest") {
            let result = new FormFilterRequest();
            result.init(data);
            return result;
        }
        throw new Error("The abstract class 'FilterRequest' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["discriminator"] = this._discriminator; 
        return data; 
    }
}

export interface IFilterRequest {
}

export class FormFilterRequest extends FilterRequest implements IFormFilterRequest {
    formId!: string;
    filterComponents!: FilterComponentRequest[];
    countToTake?: number | undefined;
    range?: number | undefined;
    rangeOptions!: RangeOptions;

    constructor(data?: IFormFilterRequest) {
        super(data);
        if (!data) {
            this.filterComponents = [];
        }
        this._discriminator = "FormFilterRequest";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.formId = _data["formId"];
            if (Array.isArray(_data["filterComponents"])) {
                this.filterComponents = [] as any;
                for (let item of _data["filterComponents"])
                    this.filterComponents!.push(FilterComponentRequest.fromJS(item));
            }
            this.countToTake = _data["countToTake"];
            this.range = _data["range"];
            this.rangeOptions = _data["rangeOptions"];
        }
    }

    static fromJS(data: any): FormFilterRequest {
        data = typeof data === 'object' ? data : {};
        let result = new FormFilterRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["formId"] = this.formId;
        if (Array.isArray(this.filterComponents)) {
            data["filterComponents"] = [];
            for (let item of this.filterComponents)
                data["filterComponents"].push(item.toJSON());
        }
        data["countToTake"] = this.countToTake;
        data["range"] = this.range;
        data["rangeOptions"] = this.rangeOptions;
        super.toJSON(data);
        return data; 
    }
}

export interface IFormFilterRequest extends IFilterRequest {
    formId: string;
    filterComponents: FilterComponentRequest[];
    countToTake?: number | undefined;
    range?: number | undefined;
    rangeOptions: RangeOptions;
}

export abstract class FilterComponentRequest implements IFilterComponentRequest {
    operator!: Operator;
    condition!: Condition;
    value!: FilterValueRequest;

    protected _discriminator: string;

    constructor(data?: IFilterComponentRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        this._discriminator = "FilterComponentRequest";
    }

    init(_data?: any) {
        if (_data) {
            this.operator = _data["operator"];
            this.condition = _data["condition"];
            this.value = _data["value"] ? FilterValueRequest.fromJS(_data["value"]) : <any>undefined;
        }
    }

    static fromJS(data: any): FilterComponentRequest {
        data = typeof data === 'object' ? data : {};
        if (data["discriminator"] === "FormFilterComponentRequest") {
            let result = new FormFilterComponentRequest();
            result.init(data);
            return result;
        }
        throw new Error("The abstract class 'FilterComponentRequest' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["discriminator"] = this._discriminator; 
        data["operator"] = this.operator;
        data["condition"] = this.condition;
        data["value"] = this.value ? this.value.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IFilterComponentRequest {
    operator: Operator;
    condition: Condition;
    value: FilterValueRequest;
}

export enum Operator {
    And = "And",
    Or = "Or",
}

export enum Condition {
    Equals = "Equals",
    NotEquals = "NotEquals",
    LessThan = "LessThan",
    GreaterThan = "GreaterThan",
    LessThanOrEqual = "LessThanOrEqual",
    GreaterThanOrEqual = "GreaterThanOrEqual",
    StringContains = "StringContains",
    AnyOf = "AnyOf",
    AllOf = "AllOf",
}

export abstract class FilterValueRequest implements IFilterValueRequest {

    protected _discriminator: string;

    constructor(data?: IFilterValueRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        this._discriminator = "FilterValueRequest";
    }

    init(_data?: any) {
    }

    static fromJS(data: any): FilterValueRequest {
        data = typeof data === 'object' ? data : {};
        if (data["discriminator"] === "FreeFormTextFormAnswerFilterValueRequest") {
            let result = new FreeFormTextFormAnswerFilterValueRequest();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "NumericValueFormAnswerFilterValueRequest") {
            let result = new NumericValueFormAnswerFilterValueRequest();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "CalculatedValueFormAnswerFilterValueRequest") {
            let result = new CalculatedValueFormAnswerFilterValueRequest();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "MultipleChoiceFormAnswerFilterValueRequest") {
            let result = new MultipleChoiceFormAnswerFilterValueRequest();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "HealthMeasurementBloodGlucoseFilterValueRequest") {
            let result = new HealthMeasurementBloodGlucoseFilterValueRequest();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "HealthMeasurementSystolicBloodPressureFilterValueRequest") {
            let result = new HealthMeasurementSystolicBloodPressureFilterValueRequest();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "HealthMeasurementDiastolicBloodPressureFilterValueRequest") {
            let result = new HealthMeasurementDiastolicBloodPressureFilterValueRequest();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "HealthMeasurementBodyTemperatureFilterValueRequest") {
            let result = new HealthMeasurementBodyTemperatureFilterValueRequest();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "HealthMeasurementBodyWeightFilterValueRequest") {
            let result = new HealthMeasurementBodyWeightFilterValueRequest();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "HealthMeasurementHeightFilterValueRequest") {
            let result = new HealthMeasurementHeightFilterValueRequest();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "HealthMeasurementHeartRateFilterValueRequest") {
            let result = new HealthMeasurementHeartRateFilterValueRequest();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "HealthMeasurementOxygenSaturationFilterValueRequest") {
            let result = new HealthMeasurementOxygenSaturationFilterValueRequest();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "HealthMeasurementRespiratoryRateFilterValueRequest") {
            let result = new HealthMeasurementRespiratoryRateFilterValueRequest();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "FluidsOfferedFormAnswerFilterValueRequest") {
            let result = new FluidsOfferedFormAnswerFilterValueRequest();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "FluidsConsumedFormAnswerFilterValueRequest") {
            let result = new FluidsConsumedFormAnswerFilterValueRequest();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "QuestionScoreSumFormAnswerFilterValueRequest") {
            let result = new QuestionScoreSumFormAnswerFilterValueRequest();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "FormScoreSumFormAnswerFilterValueRequest") {
            let result = new FormScoreSumFormAnswerFilterValueRequest();
            result.init(data);
            return result;
        }
        throw new Error("The abstract class 'FilterValueRequest' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["discriminator"] = this._discriminator; 
        return data; 
    }
}

export interface IFilterValueRequest {
}

export class FreeFormTextFormAnswerFilterValueRequest extends FilterValueRequest implements IFreeFormTextFormAnswerFilterValueRequest {
    value!: string;

    constructor(data?: IFreeFormTextFormAnswerFilterValueRequest) {
        super(data);
        this._discriminator = "FreeFormTextFormAnswerFilterValueRequest";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): FreeFormTextFormAnswerFilterValueRequest {
        data = typeof data === 'object' ? data : {};
        let result = new FreeFormTextFormAnswerFilterValueRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        super.toJSON(data);
        return data; 
    }
}

export interface IFreeFormTextFormAnswerFilterValueRequest extends IFilterValueRequest {
    value: string;
}

export class NumericValueFormAnswerFilterValueRequest extends FilterValueRequest implements INumericValueFormAnswerFilterValueRequest {
    value!: number;

    constructor(data?: INumericValueFormAnswerFilterValueRequest) {
        super(data);
        this._discriminator = "NumericValueFormAnswerFilterValueRequest";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): NumericValueFormAnswerFilterValueRequest {
        data = typeof data === 'object' ? data : {};
        let result = new NumericValueFormAnswerFilterValueRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        super.toJSON(data);
        return data; 
    }
}

export interface INumericValueFormAnswerFilterValueRequest extends IFilterValueRequest {
    value: number;
}

export class CalculatedValueFormAnswerFilterValueRequest extends FilterValueRequest implements ICalculatedValueFormAnswerFilterValueRequest {
    value!: number;

    constructor(data?: ICalculatedValueFormAnswerFilterValueRequest) {
        super(data);
        this._discriminator = "CalculatedValueFormAnswerFilterValueRequest";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): CalculatedValueFormAnswerFilterValueRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CalculatedValueFormAnswerFilterValueRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        super.toJSON(data);
        return data; 
    }
}

export interface ICalculatedValueFormAnswerFilterValueRequest extends IFilterValueRequest {
    value: number;
}

export class MultipleChoiceFormAnswerFilterValueRequest extends FilterValueRequest implements IMultipleChoiceFormAnswerFilterValueRequest {
    value!: string[];

    constructor(data?: IMultipleChoiceFormAnswerFilterValueRequest) {
        super(data);
        if (!data) {
            this.value = [];
        }
        this._discriminator = "MultipleChoiceFormAnswerFilterValueRequest";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["value"])) {
                this.value = [] as any;
                for (let item of _data["value"])
                    this.value!.push(item);
            }
        }
    }

    static fromJS(data: any): MultipleChoiceFormAnswerFilterValueRequest {
        data = typeof data === 'object' ? data : {};
        let result = new MultipleChoiceFormAnswerFilterValueRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.value)) {
            data["value"] = [];
            for (let item of this.value)
                data["value"].push(item);
        }
        super.toJSON(data);
        return data; 
    }
}

export interface IMultipleChoiceFormAnswerFilterValueRequest extends IFilterValueRequest {
    value: string[];
}

export class HealthMeasurementBloodGlucoseFilterValueRequest extends FilterValueRequest implements IHealthMeasurementBloodGlucoseFilterValueRequest {
    value!: number;

    constructor(data?: IHealthMeasurementBloodGlucoseFilterValueRequest) {
        super(data);
        this._discriminator = "HealthMeasurementBloodGlucoseFilterValueRequest";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): HealthMeasurementBloodGlucoseFilterValueRequest {
        data = typeof data === 'object' ? data : {};
        let result = new HealthMeasurementBloodGlucoseFilterValueRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        super.toJSON(data);
        return data; 
    }
}

export interface IHealthMeasurementBloodGlucoseFilterValueRequest extends IFilterValueRequest {
    value: number;
}

export class HealthMeasurementSystolicBloodPressureFilterValueRequest extends FilterValueRequest implements IHealthMeasurementSystolicBloodPressureFilterValueRequest {
    value!: number;

    constructor(data?: IHealthMeasurementSystolicBloodPressureFilterValueRequest) {
        super(data);
        this._discriminator = "HealthMeasurementSystolicBloodPressureFilterValueRequest";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): HealthMeasurementSystolicBloodPressureFilterValueRequest {
        data = typeof data === 'object' ? data : {};
        let result = new HealthMeasurementSystolicBloodPressureFilterValueRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        super.toJSON(data);
        return data; 
    }
}

export interface IHealthMeasurementSystolicBloodPressureFilterValueRequest extends IFilterValueRequest {
    value: number;
}

export class HealthMeasurementDiastolicBloodPressureFilterValueRequest extends FilterValueRequest implements IHealthMeasurementDiastolicBloodPressureFilterValueRequest {
    value!: number;

    constructor(data?: IHealthMeasurementDiastolicBloodPressureFilterValueRequest) {
        super(data);
        this._discriminator = "HealthMeasurementDiastolicBloodPressureFilterValueRequest";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): HealthMeasurementDiastolicBloodPressureFilterValueRequest {
        data = typeof data === 'object' ? data : {};
        let result = new HealthMeasurementDiastolicBloodPressureFilterValueRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        super.toJSON(data);
        return data; 
    }
}

export interface IHealthMeasurementDiastolicBloodPressureFilterValueRequest extends IFilterValueRequest {
    value: number;
}

export class HealthMeasurementBodyTemperatureFilterValueRequest extends FilterValueRequest implements IHealthMeasurementBodyTemperatureFilterValueRequest {
    value!: number;

    constructor(data?: IHealthMeasurementBodyTemperatureFilterValueRequest) {
        super(data);
        this._discriminator = "HealthMeasurementBodyTemperatureFilterValueRequest";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): HealthMeasurementBodyTemperatureFilterValueRequest {
        data = typeof data === 'object' ? data : {};
        let result = new HealthMeasurementBodyTemperatureFilterValueRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        super.toJSON(data);
        return data; 
    }
}

export interface IHealthMeasurementBodyTemperatureFilterValueRequest extends IFilterValueRequest {
    value: number;
}

export class HealthMeasurementBodyWeightFilterValueRequest extends FilterValueRequest implements IHealthMeasurementBodyWeightFilterValueRequest {
    value!: number;

    constructor(data?: IHealthMeasurementBodyWeightFilterValueRequest) {
        super(data);
        this._discriminator = "HealthMeasurementBodyWeightFilterValueRequest";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): HealthMeasurementBodyWeightFilterValueRequest {
        data = typeof data === 'object' ? data : {};
        let result = new HealthMeasurementBodyWeightFilterValueRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        super.toJSON(data);
        return data; 
    }
}

export interface IHealthMeasurementBodyWeightFilterValueRequest extends IFilterValueRequest {
    value: number;
}

export class HealthMeasurementHeightFilterValueRequest extends FilterValueRequest implements IHealthMeasurementHeightFilterValueRequest {
    value!: number;

    constructor(data?: IHealthMeasurementHeightFilterValueRequest) {
        super(data);
        this._discriminator = "HealthMeasurementHeightFilterValueRequest";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): HealthMeasurementHeightFilterValueRequest {
        data = typeof data === 'object' ? data : {};
        let result = new HealthMeasurementHeightFilterValueRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        super.toJSON(data);
        return data; 
    }
}

export interface IHealthMeasurementHeightFilterValueRequest extends IFilterValueRequest {
    value: number;
}

export class HealthMeasurementHeartRateFilterValueRequest extends FilterValueRequest implements IHealthMeasurementHeartRateFilterValueRequest {
    value!: number;

    constructor(data?: IHealthMeasurementHeartRateFilterValueRequest) {
        super(data);
        this._discriminator = "HealthMeasurementHeartRateFilterValueRequest";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): HealthMeasurementHeartRateFilterValueRequest {
        data = typeof data === 'object' ? data : {};
        let result = new HealthMeasurementHeartRateFilterValueRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        super.toJSON(data);
        return data; 
    }
}

export interface IHealthMeasurementHeartRateFilterValueRequest extends IFilterValueRequest {
    value: number;
}

export class HealthMeasurementOxygenSaturationFilterValueRequest extends FilterValueRequest implements IHealthMeasurementOxygenSaturationFilterValueRequest {
    value!: number;

    constructor(data?: IHealthMeasurementOxygenSaturationFilterValueRequest) {
        super(data);
        this._discriminator = "HealthMeasurementOxygenSaturationFilterValueRequest";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): HealthMeasurementOxygenSaturationFilterValueRequest {
        data = typeof data === 'object' ? data : {};
        let result = new HealthMeasurementOxygenSaturationFilterValueRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        super.toJSON(data);
        return data; 
    }
}

export interface IHealthMeasurementOxygenSaturationFilterValueRequest extends IFilterValueRequest {
    value: number;
}

export class HealthMeasurementRespiratoryRateFilterValueRequest extends FilterValueRequest implements IHealthMeasurementRespiratoryRateFilterValueRequest {
    value!: number;

    constructor(data?: IHealthMeasurementRespiratoryRateFilterValueRequest) {
        super(data);
        this._discriminator = "HealthMeasurementRespiratoryRateFilterValueRequest";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): HealthMeasurementRespiratoryRateFilterValueRequest {
        data = typeof data === 'object' ? data : {};
        let result = new HealthMeasurementRespiratoryRateFilterValueRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        super.toJSON(data);
        return data; 
    }
}

export interface IHealthMeasurementRespiratoryRateFilterValueRequest extends IFilterValueRequest {
    value: number;
}

export class FluidsOfferedFormAnswerFilterValueRequest extends FilterValueRequest implements IFluidsOfferedFormAnswerFilterValueRequest {
    value!: number;

    constructor(data?: IFluidsOfferedFormAnswerFilterValueRequest) {
        super(data);
        this._discriminator = "FluidsOfferedFormAnswerFilterValueRequest";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): FluidsOfferedFormAnswerFilterValueRequest {
        data = typeof data === 'object' ? data : {};
        let result = new FluidsOfferedFormAnswerFilterValueRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        super.toJSON(data);
        return data; 
    }
}

export interface IFluidsOfferedFormAnswerFilterValueRequest extends IFilterValueRequest {
    value: number;
}

export class FluidsConsumedFormAnswerFilterValueRequest extends FilterValueRequest implements IFluidsConsumedFormAnswerFilterValueRequest {
    value!: number;

    constructor(data?: IFluidsConsumedFormAnswerFilterValueRequest) {
        super(data);
        this._discriminator = "FluidsConsumedFormAnswerFilterValueRequest";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): FluidsConsumedFormAnswerFilterValueRequest {
        data = typeof data === 'object' ? data : {};
        let result = new FluidsConsumedFormAnswerFilterValueRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        super.toJSON(data);
        return data; 
    }
}

export interface IFluidsConsumedFormAnswerFilterValueRequest extends IFilterValueRequest {
    value: number;
}

export class QuestionScoreSumFormAnswerFilterValueRequest extends FilterValueRequest implements IQuestionScoreSumFormAnswerFilterValueRequest {
    value!: number;

    constructor(data?: IQuestionScoreSumFormAnswerFilterValueRequest) {
        super(data);
        this._discriminator = "QuestionScoreSumFormAnswerFilterValueRequest";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): QuestionScoreSumFormAnswerFilterValueRequest {
        data = typeof data === 'object' ? data : {};
        let result = new QuestionScoreSumFormAnswerFilterValueRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        super.toJSON(data);
        return data; 
    }
}

export interface IQuestionScoreSumFormAnswerFilterValueRequest extends IFilterValueRequest {
    value: number;
}

export class FormScoreSumFormAnswerFilterValueRequest extends FilterValueRequest implements IFormScoreSumFormAnswerFilterValueRequest {
    value!: number;

    constructor(data?: IFormScoreSumFormAnswerFilterValueRequest) {
        super(data);
        this._discriminator = "FormScoreSumFormAnswerFilterValueRequest";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): FormScoreSumFormAnswerFilterValueRequest {
        data = typeof data === 'object' ? data : {};
        let result = new FormScoreSumFormAnswerFilterValueRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        super.toJSON(data);
        return data; 
    }
}

export interface IFormScoreSumFormAnswerFilterValueRequest extends IFilterValueRequest {
    value: number;
}

export class FormFilterComponentRequest extends FilterComponentRequest implements IFormFilterComponentRequest {
    stepId!: string;

    constructor(data?: IFormFilterComponentRequest) {
        super(data);
        this._discriminator = "FormFilterComponentRequest";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.stepId = _data["stepId"];
        }
    }

    static fromJS(data: any): FormFilterComponentRequest {
        data = typeof data === 'object' ? data : {};
        let result = new FormFilterComponentRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["stepId"] = this.stepId;
        super.toJSON(data);
        return data; 
    }
}

export interface IFormFilterComponentRequest extends IFilterComponentRequest {
    stepId: string;
}

export enum RangeOptions {
    Days = "Days",
    Hours = "Hours",
    Weeks = "Weeks",
    Months = "Months",
    Yesterday = "Yesterday",
    LastWeek = "LastWeek",
    LastMonth = "LastMonth",
}

export abstract class WidgetDisplayPropertyRequest implements IWidgetDisplayPropertyRequest {
    order!: number;

    protected _discriminator: string;

    constructor(data?: IWidgetDisplayPropertyRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        this._discriminator = "WidgetDisplayPropertyRequest";
    }

    init(_data?: any) {
        if (_data) {
            this.order = _data["order"];
        }
    }

    static fromJS(data: any): WidgetDisplayPropertyRequest {
        data = typeof data === 'object' ? data : {};
        if (data["discriminator"] === "FormMetadataWidgetDisplayPropertyRequest") {
            let result = new FormMetadataWidgetDisplayPropertyRequest();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "FormAnswerWidgetDisplayPropertyRequest") {
            let result = new FormAnswerWidgetDisplayPropertyRequest();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "FormAnswerWidgetSpecificValueDisplayPropertyRequest") {
            let result = new FormAnswerWidgetSpecificValueDisplayPropertyRequest();
            result.init(data);
            return result;
        }
        throw new Error("The abstract class 'WidgetDisplayPropertyRequest' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["discriminator"] = this._discriminator; 
        data["order"] = this.order;
        return data; 
    }
}

export interface IWidgetDisplayPropertyRequest {
    order: number;
}

export class FormMetadataWidgetDisplayPropertyRequest extends WidgetDisplayPropertyRequest implements IFormMetadataWidgetDisplayPropertyRequest {
    displayProperty!: FormMetadataDisplayPropertyValue;

    constructor(data?: IFormMetadataWidgetDisplayPropertyRequest) {
        super(data);
        this._discriminator = "FormMetadataWidgetDisplayPropertyRequest";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.displayProperty = _data["displayProperty"];
        }
    }

    static fromJS(data: any): FormMetadataWidgetDisplayPropertyRequest {
        data = typeof data === 'object' ? data : {};
        let result = new FormMetadataWidgetDisplayPropertyRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["displayProperty"] = this.displayProperty;
        super.toJSON(data);
        return data; 
    }
}

export interface IFormMetadataWidgetDisplayPropertyRequest extends IWidgetDisplayPropertyRequest {
    displayProperty: FormMetadataDisplayPropertyValue;
}

export enum FormMetadataDisplayPropertyValue {
    ObservedAt = "ObservedAt",
    RegisteredBy = "RegisteredBy",
    FormScoreSum = "FormScoreSum",
}

export class FormAnswerWidgetDisplayPropertyRequest extends WidgetDisplayPropertyRequest implements IFormAnswerWidgetDisplayPropertyRequest {
    stepId!: string;

    constructor(data?: IFormAnswerWidgetDisplayPropertyRequest) {
        super(data);
        this._discriminator = "FormAnswerWidgetDisplayPropertyRequest";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.stepId = _data["stepId"];
        }
    }

    static fromJS(data: any): FormAnswerWidgetDisplayPropertyRequest {
        data = typeof data === 'object' ? data : {};
        if (data["discriminator"] === "FormAnswerWidgetSpecificValueDisplayPropertyRequest") {
            let result = new FormAnswerWidgetSpecificValueDisplayPropertyRequest();
            result.init(data);
            return result;
        }
        let result = new FormAnswerWidgetDisplayPropertyRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["stepId"] = this.stepId;
        super.toJSON(data);
        return data; 
    }
}

export interface IFormAnswerWidgetDisplayPropertyRequest extends IWidgetDisplayPropertyRequest {
    stepId: string;
}

export class FormAnswerWidgetSpecificValueDisplayPropertyRequest extends FormAnswerWidgetDisplayPropertyRequest implements IFormAnswerWidgetSpecificValueDisplayPropertyRequest {
    valueToDisplay!: FormAnswerSpecificValueToDisplay;

    constructor(data?: IFormAnswerWidgetSpecificValueDisplayPropertyRequest) {
        super(data);
        this._discriminator = "FormAnswerWidgetSpecificValueDisplayPropertyRequest";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.valueToDisplay = _data["valueToDisplay"];
        }
    }

    static fromJS(data: any): FormAnswerWidgetSpecificValueDisplayPropertyRequest {
        data = typeof data === 'object' ? data : {};
        let result = new FormAnswerWidgetSpecificValueDisplayPropertyRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["valueToDisplay"] = this.valueToDisplay;
        super.toJSON(data);
        return data; 
    }
}

export interface IFormAnswerWidgetSpecificValueDisplayPropertyRequest extends IFormAnswerWidgetDisplayPropertyRequest {
    valueToDisplay: FormAnswerSpecificValueToDisplay;
}

export enum FormAnswerSpecificValueToDisplay {
    FluidsOffered = "FluidsOffered",
    FluidsConsumed = "FluidsConsumed",
    BloodPressureSystolic = "BloodPressureSystolic",
    BloodPressureDiastolic = "BloodPressureDiastolic",
    QuestionScoreSum = "QuestionScoreSum",
}

export class DashboardResponse implements IDashboardResponse {
    id!: string;
    title!: string;
    enabledInAdmin!: boolean;
    enabledInOneCare!: boolean;
    order!: number;
    ownerId!: string;
    widgets!: DashboardWidgetResponse[];
    sharedWithOrganisationIds!: string[];

    constructor(data?: IDashboardResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.widgets = [];
            this.sharedWithOrganisationIds = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.title = _data["title"];
            this.enabledInAdmin = _data["enabledInAdmin"];
            this.enabledInOneCare = _data["enabledInOneCare"];
            this.order = _data["order"];
            this.ownerId = _data["ownerId"];
            if (Array.isArray(_data["widgets"])) {
                this.widgets = [] as any;
                for (let item of _data["widgets"])
                    this.widgets!.push(DashboardWidgetResponse.fromJS(item));
            }
            if (Array.isArray(_data["sharedWithOrganisationIds"])) {
                this.sharedWithOrganisationIds = [] as any;
                for (let item of _data["sharedWithOrganisationIds"])
                    this.sharedWithOrganisationIds!.push(item);
            }
        }
    }

    static fromJS(data: any): DashboardResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DashboardResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["title"] = this.title;
        data["enabledInAdmin"] = this.enabledInAdmin;
        data["enabledInOneCare"] = this.enabledInOneCare;
        data["order"] = this.order;
        data["ownerId"] = this.ownerId;
        if (Array.isArray(this.widgets)) {
            data["widgets"] = [];
            for (let item of this.widgets)
                data["widgets"].push(item.toJSON());
        }
        if (Array.isArray(this.sharedWithOrganisationIds)) {
            data["sharedWithOrganisationIds"] = [];
            for (let item of this.sharedWithOrganisationIds)
                data["sharedWithOrganisationIds"].push(item);
        }
        return data; 
    }
}

export interface IDashboardResponse {
    id: string;
    title: string;
    enabledInAdmin: boolean;
    enabledInOneCare: boolean;
    order: number;
    ownerId: string;
    widgets: DashboardWidgetResponse[];
    sharedWithOrganisationIds: string[];
}

export class DashboardWidgetResponse implements IDashboardWidgetResponse {
    id!: string;
    dataSource!: DataSource;
    displayType!: DisplayType;
    filter?: WidgetFilterResponse | undefined;
    displayProperties!: WidgetDisplayPropertyResponse[];
    enabledInOnecare!: boolean;
    enabledInAdmin!: boolean;
    title!: string;
    order!: number;

    constructor(data?: IDashboardWidgetResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.displayProperties = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.dataSource = _data["dataSource"];
            this.displayType = _data["displayType"];
            this.filter = _data["filter"] ? WidgetFilterResponse.fromJS(_data["filter"]) : <any>undefined;
            if (Array.isArray(_data["displayProperties"])) {
                this.displayProperties = [] as any;
                for (let item of _data["displayProperties"])
                    this.displayProperties!.push(WidgetDisplayPropertyResponse.fromJS(item));
            }
            this.enabledInOnecare = _data["enabledInOnecare"];
            this.enabledInAdmin = _data["enabledInAdmin"];
            this.title = _data["title"];
            this.order = _data["order"];
        }
    }

    static fromJS(data: any): DashboardWidgetResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DashboardWidgetResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["dataSource"] = this.dataSource;
        data["displayType"] = this.displayType;
        data["filter"] = this.filter ? this.filter.toJSON() : <any>undefined;
        if (Array.isArray(this.displayProperties)) {
            data["displayProperties"] = [];
            for (let item of this.displayProperties)
                data["displayProperties"].push(item.toJSON());
        }
        data["enabledInOnecare"] = this.enabledInOnecare;
        data["enabledInAdmin"] = this.enabledInAdmin;
        data["title"] = this.title;
        data["order"] = this.order;
        return data; 
    }
}

export interface IDashboardWidgetResponse {
    id: string;
    dataSource: DataSource;
    displayType: DisplayType;
    filter?: WidgetFilterResponse | undefined;
    displayProperties: WidgetDisplayPropertyResponse[];
    enabledInOnecare: boolean;
    enabledInAdmin: boolean;
    title: string;
    order: number;
}

export abstract class WidgetFilterResponse implements IWidgetFilterResponse {

    protected _discriminator: string;

    constructor(data?: IWidgetFilterResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        this._discriminator = "WidgetFilterResponse";
    }

    init(_data?: any) {
    }

    static fromJS(data: any): WidgetFilterResponse {
        data = typeof data === 'object' ? data : {};
        if (data["discriminator"] === "FormFilterResponse") {
            let result = new FormFilterResponse();
            result.init(data);
            return result;
        }
        throw new Error("The abstract class 'WidgetFilterResponse' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["discriminator"] = this._discriminator; 
        return data; 
    }
}

export interface IWidgetFilterResponse {
}

export class FormFilterResponse extends WidgetFilterResponse implements IFormFilterResponse {
    formId!: string;
    filterComponents!: FilterComponentResponse[];
    countToTake?: number | undefined;
    range?: number | undefined;
    rangeOptions!: RangeOptions;

    constructor(data?: IFormFilterResponse) {
        super(data);
        if (!data) {
            this.filterComponents = [];
        }
        this._discriminator = "FormFilterResponse";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.formId = _data["formId"];
            if (Array.isArray(_data["filterComponents"])) {
                this.filterComponents = [] as any;
                for (let item of _data["filterComponents"])
                    this.filterComponents!.push(FilterComponentResponse.fromJS(item));
            }
            this.countToTake = _data["countToTake"];
            this.range = _data["range"];
            this.rangeOptions = _data["rangeOptions"];
        }
    }

    static fromJS(data: any): FormFilterResponse {
        data = typeof data === 'object' ? data : {};
        let result = new FormFilterResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["formId"] = this.formId;
        if (Array.isArray(this.filterComponents)) {
            data["filterComponents"] = [];
            for (let item of this.filterComponents)
                data["filterComponents"].push(item.toJSON());
        }
        data["countToTake"] = this.countToTake;
        data["range"] = this.range;
        data["rangeOptions"] = this.rangeOptions;
        super.toJSON(data);
        return data; 
    }
}

export interface IFormFilterResponse extends IWidgetFilterResponse {
    formId: string;
    filterComponents: FilterComponentResponse[];
    countToTake?: number | undefined;
    range?: number | undefined;
    rangeOptions: RangeOptions;
}

export abstract class FilterComponentResponse implements IFilterComponentResponse {
    operator!: Operator;
    condition!: Condition;
    value!: FilterValueResponse;

    protected _discriminator: string;

    constructor(data?: IFilterComponentResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        this._discriminator = "FilterComponentResponse";
    }

    init(_data?: any) {
        if (_data) {
            this.operator = _data["operator"];
            this.condition = _data["condition"];
            this.value = _data["value"] ? FilterValueResponse.fromJS(_data["value"]) : <any>undefined;
        }
    }

    static fromJS(data: any): FilterComponentResponse {
        data = typeof data === 'object' ? data : {};
        if (data["discriminator"] === "FormFilterComponentResponse") {
            let result = new FormFilterComponentResponse();
            result.init(data);
            return result;
        }
        throw new Error("The abstract class 'FilterComponentResponse' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["discriminator"] = this._discriminator; 
        data["operator"] = this.operator;
        data["condition"] = this.condition;
        data["value"] = this.value ? this.value.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IFilterComponentResponse {
    operator: Operator;
    condition: Condition;
    value: FilterValueResponse;
}

export abstract class FilterValueResponse implements IFilterValueResponse {

    protected _discriminator: string;

    constructor(data?: IFilterValueResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        this._discriminator = "FilterValueResponse";
    }

    init(_data?: any) {
    }

    static fromJS(data: any): FilterValueResponse {
        data = typeof data === 'object' ? data : {};
        if (data["discriminator"] === "FreeFormTextFormAnswerFilterValueResponse") {
            let result = new FreeFormTextFormAnswerFilterValueResponse();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "NumericValueFormAnswerFilterValueResponse") {
            let result = new NumericValueFormAnswerFilterValueResponse();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "CalculatedValueFormAnswerFilterValueResponse") {
            let result = new CalculatedValueFormAnswerFilterValueResponse();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "MultipleChoiceFormAnswerFilterValueResponse") {
            let result = new MultipleChoiceFormAnswerFilterValueResponse();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "HealthMeasurementBloodGlucoseFilterValueResponse") {
            let result = new HealthMeasurementBloodGlucoseFilterValueResponse();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "HealthMeasurementSystolicBloodPressureFilterValueResponse") {
            let result = new HealthMeasurementSystolicBloodPressureFilterValueResponse();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "HealthMeasurementDiastolicBloodPressureFilterValueResponse") {
            let result = new HealthMeasurementDiastolicBloodPressureFilterValueResponse();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "HealthMeasurementBodyTemperatureFilterValueResponse") {
            let result = new HealthMeasurementBodyTemperatureFilterValueResponse();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "HealthMeasurementBodyWeightFilterValueResponse") {
            let result = new HealthMeasurementBodyWeightFilterValueResponse();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "HealthMeasurementHeightFilterValueResponse") {
            let result = new HealthMeasurementHeightFilterValueResponse();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "HealthMeasurementHeartRateFilterValueResponse") {
            let result = new HealthMeasurementHeartRateFilterValueResponse();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "HealthMeasurementOxygenSaturationFilterValueResponse") {
            let result = new HealthMeasurementOxygenSaturationFilterValueResponse();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "HealthMeasurementRespiratoryRateFilterValueResponse") {
            let result = new HealthMeasurementRespiratoryRateFilterValueResponse();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "FluidsOfferedFormAnswerFilterValueResponse") {
            let result = new FluidsOfferedFormAnswerFilterValueResponse();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "FluidsConsumedFormAnswerFilterValueResponse") {
            let result = new FluidsConsumedFormAnswerFilterValueResponse();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "QuestionScoreSumFormAnswerFilterValueResponse") {
            let result = new QuestionScoreSumFormAnswerFilterValueResponse();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "FormScoreSumFormAnswerFilterValueResponse") {
            let result = new FormScoreSumFormAnswerFilterValueResponse();
            result.init(data);
            return result;
        }
        throw new Error("The abstract class 'FilterValueResponse' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["discriminator"] = this._discriminator; 
        return data; 
    }
}

export interface IFilterValueResponse {
}

export class FreeFormTextFormAnswerFilterValueResponse extends FilterValueResponse implements IFreeFormTextFormAnswerFilterValueResponse {
    value!: string;

    constructor(data?: IFreeFormTextFormAnswerFilterValueResponse) {
        super(data);
        this._discriminator = "FreeFormTextFormAnswerFilterValueResponse";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): FreeFormTextFormAnswerFilterValueResponse {
        data = typeof data === 'object' ? data : {};
        let result = new FreeFormTextFormAnswerFilterValueResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        super.toJSON(data);
        return data; 
    }
}

export interface IFreeFormTextFormAnswerFilterValueResponse extends IFilterValueResponse {
    value: string;
}

export class NumericValueFormAnswerFilterValueResponse extends FilterValueResponse implements INumericValueFormAnswerFilterValueResponse {
    value!: number;

    constructor(data?: INumericValueFormAnswerFilterValueResponse) {
        super(data);
        this._discriminator = "NumericValueFormAnswerFilterValueResponse";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): NumericValueFormAnswerFilterValueResponse {
        data = typeof data === 'object' ? data : {};
        let result = new NumericValueFormAnswerFilterValueResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        super.toJSON(data);
        return data; 
    }
}

export interface INumericValueFormAnswerFilterValueResponse extends IFilterValueResponse {
    value: number;
}

export class CalculatedValueFormAnswerFilterValueResponse extends FilterValueResponse implements ICalculatedValueFormAnswerFilterValueResponse {
    value!: number;

    constructor(data?: ICalculatedValueFormAnswerFilterValueResponse) {
        super(data);
        this._discriminator = "CalculatedValueFormAnswerFilterValueResponse";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): CalculatedValueFormAnswerFilterValueResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CalculatedValueFormAnswerFilterValueResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        super.toJSON(data);
        return data; 
    }
}

export interface ICalculatedValueFormAnswerFilterValueResponse extends IFilterValueResponse {
    value: number;
}

export class MultipleChoiceFormAnswerFilterValueResponse extends FilterValueResponse implements IMultipleChoiceFormAnswerFilterValueResponse {
    value!: string[];

    constructor(data?: IMultipleChoiceFormAnswerFilterValueResponse) {
        super(data);
        if (!data) {
            this.value = [];
        }
        this._discriminator = "MultipleChoiceFormAnswerFilterValueResponse";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["value"])) {
                this.value = [] as any;
                for (let item of _data["value"])
                    this.value!.push(item);
            }
        }
    }

    static fromJS(data: any): MultipleChoiceFormAnswerFilterValueResponse {
        data = typeof data === 'object' ? data : {};
        let result = new MultipleChoiceFormAnswerFilterValueResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.value)) {
            data["value"] = [];
            for (let item of this.value)
                data["value"].push(item);
        }
        super.toJSON(data);
        return data; 
    }
}

export interface IMultipleChoiceFormAnswerFilterValueResponse extends IFilterValueResponse {
    value: string[];
}

export class HealthMeasurementBloodGlucoseFilterValueResponse extends FilterValueResponse implements IHealthMeasurementBloodGlucoseFilterValueResponse {
    value!: number;

    constructor(data?: IHealthMeasurementBloodGlucoseFilterValueResponse) {
        super(data);
        this._discriminator = "HealthMeasurementBloodGlucoseFilterValueResponse";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): HealthMeasurementBloodGlucoseFilterValueResponse {
        data = typeof data === 'object' ? data : {};
        let result = new HealthMeasurementBloodGlucoseFilterValueResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        super.toJSON(data);
        return data; 
    }
}

export interface IHealthMeasurementBloodGlucoseFilterValueResponse extends IFilterValueResponse {
    value: number;
}

export class HealthMeasurementSystolicBloodPressureFilterValueResponse extends FilterValueResponse implements IHealthMeasurementSystolicBloodPressureFilterValueResponse {
    value!: number;

    constructor(data?: IHealthMeasurementSystolicBloodPressureFilterValueResponse) {
        super(data);
        this._discriminator = "HealthMeasurementSystolicBloodPressureFilterValueResponse";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): HealthMeasurementSystolicBloodPressureFilterValueResponse {
        data = typeof data === 'object' ? data : {};
        let result = new HealthMeasurementSystolicBloodPressureFilterValueResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        super.toJSON(data);
        return data; 
    }
}

export interface IHealthMeasurementSystolicBloodPressureFilterValueResponse extends IFilterValueResponse {
    value: number;
}

export class HealthMeasurementDiastolicBloodPressureFilterValueResponse extends FilterValueResponse implements IHealthMeasurementDiastolicBloodPressureFilterValueResponse {
    value!: number;

    constructor(data?: IHealthMeasurementDiastolicBloodPressureFilterValueResponse) {
        super(data);
        this._discriminator = "HealthMeasurementDiastolicBloodPressureFilterValueResponse";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): HealthMeasurementDiastolicBloodPressureFilterValueResponse {
        data = typeof data === 'object' ? data : {};
        let result = new HealthMeasurementDiastolicBloodPressureFilterValueResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        super.toJSON(data);
        return data; 
    }
}

export interface IHealthMeasurementDiastolicBloodPressureFilterValueResponse extends IFilterValueResponse {
    value: number;
}

export class HealthMeasurementBodyTemperatureFilterValueResponse extends FilterValueResponse implements IHealthMeasurementBodyTemperatureFilterValueResponse {
    value!: number;

    constructor(data?: IHealthMeasurementBodyTemperatureFilterValueResponse) {
        super(data);
        this._discriminator = "HealthMeasurementBodyTemperatureFilterValueResponse";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): HealthMeasurementBodyTemperatureFilterValueResponse {
        data = typeof data === 'object' ? data : {};
        let result = new HealthMeasurementBodyTemperatureFilterValueResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        super.toJSON(data);
        return data; 
    }
}

export interface IHealthMeasurementBodyTemperatureFilterValueResponse extends IFilterValueResponse {
    value: number;
}

export class HealthMeasurementBodyWeightFilterValueResponse extends FilterValueResponse implements IHealthMeasurementBodyWeightFilterValueResponse {
    value!: number;

    constructor(data?: IHealthMeasurementBodyWeightFilterValueResponse) {
        super(data);
        this._discriminator = "HealthMeasurementBodyWeightFilterValueResponse";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): HealthMeasurementBodyWeightFilterValueResponse {
        data = typeof data === 'object' ? data : {};
        let result = new HealthMeasurementBodyWeightFilterValueResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        super.toJSON(data);
        return data; 
    }
}

export interface IHealthMeasurementBodyWeightFilterValueResponse extends IFilterValueResponse {
    value: number;
}

export class HealthMeasurementHeightFilterValueResponse extends FilterValueResponse implements IHealthMeasurementHeightFilterValueResponse {
    value!: number;

    constructor(data?: IHealthMeasurementHeightFilterValueResponse) {
        super(data);
        this._discriminator = "HealthMeasurementHeightFilterValueResponse";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): HealthMeasurementHeightFilterValueResponse {
        data = typeof data === 'object' ? data : {};
        let result = new HealthMeasurementHeightFilterValueResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        super.toJSON(data);
        return data; 
    }
}

export interface IHealthMeasurementHeightFilterValueResponse extends IFilterValueResponse {
    value: number;
}

export class HealthMeasurementHeartRateFilterValueResponse extends FilterValueResponse implements IHealthMeasurementHeartRateFilterValueResponse {
    value!: number;

    constructor(data?: IHealthMeasurementHeartRateFilterValueResponse) {
        super(data);
        this._discriminator = "HealthMeasurementHeartRateFilterValueResponse";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): HealthMeasurementHeartRateFilterValueResponse {
        data = typeof data === 'object' ? data : {};
        let result = new HealthMeasurementHeartRateFilterValueResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        super.toJSON(data);
        return data; 
    }
}

export interface IHealthMeasurementHeartRateFilterValueResponse extends IFilterValueResponse {
    value: number;
}

export class HealthMeasurementOxygenSaturationFilterValueResponse extends FilterValueResponse implements IHealthMeasurementOxygenSaturationFilterValueResponse {
    value!: number;

    constructor(data?: IHealthMeasurementOxygenSaturationFilterValueResponse) {
        super(data);
        this._discriminator = "HealthMeasurementOxygenSaturationFilterValueResponse";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): HealthMeasurementOxygenSaturationFilterValueResponse {
        data = typeof data === 'object' ? data : {};
        let result = new HealthMeasurementOxygenSaturationFilterValueResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        super.toJSON(data);
        return data; 
    }
}

export interface IHealthMeasurementOxygenSaturationFilterValueResponse extends IFilterValueResponse {
    value: number;
}

export class HealthMeasurementRespiratoryRateFilterValueResponse extends FilterValueResponse implements IHealthMeasurementRespiratoryRateFilterValueResponse {
    value!: number;

    constructor(data?: IHealthMeasurementRespiratoryRateFilterValueResponse) {
        super(data);
        this._discriminator = "HealthMeasurementRespiratoryRateFilterValueResponse";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): HealthMeasurementRespiratoryRateFilterValueResponse {
        data = typeof data === 'object' ? data : {};
        let result = new HealthMeasurementRespiratoryRateFilterValueResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        super.toJSON(data);
        return data; 
    }
}

export interface IHealthMeasurementRespiratoryRateFilterValueResponse extends IFilterValueResponse {
    value: number;
}

export class FluidsOfferedFormAnswerFilterValueResponse extends FilterValueResponse implements IFluidsOfferedFormAnswerFilterValueResponse {
    value!: number;

    constructor(data?: IFluidsOfferedFormAnswerFilterValueResponse) {
        super(data);
        this._discriminator = "FluidsOfferedFormAnswerFilterValueResponse";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): FluidsOfferedFormAnswerFilterValueResponse {
        data = typeof data === 'object' ? data : {};
        let result = new FluidsOfferedFormAnswerFilterValueResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        super.toJSON(data);
        return data; 
    }
}

export interface IFluidsOfferedFormAnswerFilterValueResponse extends IFilterValueResponse {
    value: number;
}

export class FluidsConsumedFormAnswerFilterValueResponse extends FilterValueResponse implements IFluidsConsumedFormAnswerFilterValueResponse {
    value!: number;

    constructor(data?: IFluidsConsumedFormAnswerFilterValueResponse) {
        super(data);
        this._discriminator = "FluidsConsumedFormAnswerFilterValueResponse";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): FluidsConsumedFormAnswerFilterValueResponse {
        data = typeof data === 'object' ? data : {};
        let result = new FluidsConsumedFormAnswerFilterValueResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        super.toJSON(data);
        return data; 
    }
}

export interface IFluidsConsumedFormAnswerFilterValueResponse extends IFilterValueResponse {
    value: number;
}

export class QuestionScoreSumFormAnswerFilterValueResponse extends FilterValueResponse implements IQuestionScoreSumFormAnswerFilterValueResponse {
    value!: number;

    constructor(data?: IQuestionScoreSumFormAnswerFilterValueResponse) {
        super(data);
        this._discriminator = "QuestionScoreSumFormAnswerFilterValueResponse";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): QuestionScoreSumFormAnswerFilterValueResponse {
        data = typeof data === 'object' ? data : {};
        let result = new QuestionScoreSumFormAnswerFilterValueResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        super.toJSON(data);
        return data; 
    }
}

export interface IQuestionScoreSumFormAnswerFilterValueResponse extends IFilterValueResponse {
    value: number;
}

export class FormScoreSumFormAnswerFilterValueResponse extends FilterValueResponse implements IFormScoreSumFormAnswerFilterValueResponse {
    value!: number;

    constructor(data?: IFormScoreSumFormAnswerFilterValueResponse) {
        super(data);
        this._discriminator = "FormScoreSumFormAnswerFilterValueResponse";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): FormScoreSumFormAnswerFilterValueResponse {
        data = typeof data === 'object' ? data : {};
        let result = new FormScoreSumFormAnswerFilterValueResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        super.toJSON(data);
        return data; 
    }
}

export interface IFormScoreSumFormAnswerFilterValueResponse extends IFilterValueResponse {
    value: number;
}

export class FormFilterComponentResponse extends FilterComponentResponse implements IFormFilterComponentResponse {
    stepId!: string;

    constructor(data?: IFormFilterComponentResponse) {
        super(data);
        this._discriminator = "FormFilterComponentResponse";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.stepId = _data["stepId"];
        }
    }

    static fromJS(data: any): FormFilterComponentResponse {
        data = typeof data === 'object' ? data : {};
        let result = new FormFilterComponentResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["stepId"] = this.stepId;
        super.toJSON(data);
        return data; 
    }
}

export interface IFormFilterComponentResponse extends IFilterComponentResponse {
    stepId: string;
}

export abstract class WidgetDisplayPropertyResponse implements IWidgetDisplayPropertyResponse {
    order!: number;

    protected _discriminator: string;

    constructor(data?: IWidgetDisplayPropertyResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        this._discriminator = "WidgetDisplayPropertyResponse";
    }

    init(_data?: any) {
        if (_data) {
            this.order = _data["order"];
        }
    }

    static fromJS(data: any): WidgetDisplayPropertyResponse {
        data = typeof data === 'object' ? data : {};
        if (data["discriminator"] === "FormMetadataWidgetDisplayPropertyResponse") {
            let result = new FormMetadataWidgetDisplayPropertyResponse();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "FormAnswerWidgetDisplayPropertyResponse") {
            let result = new FormAnswerWidgetDisplayPropertyResponse();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "FormAnswerWidgetSpecificValueDisplayPropertyResponse") {
            let result = new FormAnswerWidgetSpecificValueDisplayPropertyResponse();
            result.init(data);
            return result;
        }
        throw new Error("The abstract class 'WidgetDisplayPropertyResponse' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["discriminator"] = this._discriminator; 
        data["order"] = this.order;
        return data; 
    }
}

export interface IWidgetDisplayPropertyResponse {
    order: number;
}

export class FormMetadataWidgetDisplayPropertyResponse extends WidgetDisplayPropertyResponse implements IFormMetadataWidgetDisplayPropertyResponse {
    displayProperty!: FormMetadataDisplayPropertyValue;

    constructor(data?: IFormMetadataWidgetDisplayPropertyResponse) {
        super(data);
        this._discriminator = "FormMetadataWidgetDisplayPropertyResponse";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.displayProperty = _data["displayProperty"];
        }
    }

    static fromJS(data: any): FormMetadataWidgetDisplayPropertyResponse {
        data = typeof data === 'object' ? data : {};
        let result = new FormMetadataWidgetDisplayPropertyResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["displayProperty"] = this.displayProperty;
        super.toJSON(data);
        return data; 
    }
}

export interface IFormMetadataWidgetDisplayPropertyResponse extends IWidgetDisplayPropertyResponse {
    displayProperty: FormMetadataDisplayPropertyValue;
}

export class FormAnswerWidgetDisplayPropertyResponse extends WidgetDisplayPropertyResponse implements IFormAnswerWidgetDisplayPropertyResponse {
    stepId!: string;

    constructor(data?: IFormAnswerWidgetDisplayPropertyResponse) {
        super(data);
        this._discriminator = "FormAnswerWidgetDisplayPropertyResponse";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.stepId = _data["stepId"];
        }
    }

    static fromJS(data: any): FormAnswerWidgetDisplayPropertyResponse {
        data = typeof data === 'object' ? data : {};
        if (data["discriminator"] === "FormAnswerWidgetSpecificValueDisplayPropertyResponse") {
            let result = new FormAnswerWidgetSpecificValueDisplayPropertyResponse();
            result.init(data);
            return result;
        }
        let result = new FormAnswerWidgetDisplayPropertyResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["stepId"] = this.stepId;
        super.toJSON(data);
        return data; 
    }
}

export interface IFormAnswerWidgetDisplayPropertyResponse extends IWidgetDisplayPropertyResponse {
    stepId: string;
}

export class FormAnswerWidgetSpecificValueDisplayPropertyResponse extends FormAnswerWidgetDisplayPropertyResponse implements IFormAnswerWidgetSpecificValueDisplayPropertyResponse {
    valueToDisplay!: FormAnswerSpecificValueToDisplay;

    constructor(data?: IFormAnswerWidgetSpecificValueDisplayPropertyResponse) {
        super(data);
        this._discriminator = "FormAnswerWidgetSpecificValueDisplayPropertyResponse";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.valueToDisplay = _data["valueToDisplay"];
        }
    }

    static fromJS(data: any): FormAnswerWidgetSpecificValueDisplayPropertyResponse {
        data = typeof data === 'object' ? data : {};
        let result = new FormAnswerWidgetSpecificValueDisplayPropertyResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["valueToDisplay"] = this.valueToDisplay;
        super.toJSON(data);
        return data; 
    }
}

export interface IFormAnswerWidgetSpecificValueDisplayPropertyResponse extends IFormAnswerWidgetDisplayPropertyResponse {
    valueToDisplay: FormAnswerSpecificValueToDisplay;
}

export class CreateDashboardResponse implements ICreateDashboardResponse {
    id!: string;

    constructor(data?: ICreateDashboardResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateDashboardResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CreateDashboardResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data; 
    }
}

export interface ICreateDashboardResponse {
    id: string;
}

export class CreateDashboardRequest implements ICreateDashboardRequest {
    title!: string;
    ownerId!: string;
    sharedWithOrganisationIds!: string[];

    constructor(data?: ICreateDashboardRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.sharedWithOrganisationIds = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.title = _data["title"];
            this.ownerId = _data["ownerId"];
            if (Array.isArray(_data["sharedWithOrganisationIds"])) {
                this.sharedWithOrganisationIds = [] as any;
                for (let item of _data["sharedWithOrganisationIds"])
                    this.sharedWithOrganisationIds!.push(item);
            }
        }
    }

    static fromJS(data: any): CreateDashboardRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateDashboardRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["ownerId"] = this.ownerId;
        if (Array.isArray(this.sharedWithOrganisationIds)) {
            data["sharedWithOrganisationIds"] = [];
            for (let item of this.sharedWithOrganisationIds)
                data["sharedWithOrganisationIds"].push(item);
        }
        return data; 
    }
}

export interface ICreateDashboardRequest {
    title: string;
    ownerId: string;
    sharedWithOrganisationIds: string[];
}

export class UpdateDashboardRequest implements IUpdateDashboardRequest {
    title!: string;
    enabledInAdmin!: boolean;
    enabledInOneCare!: boolean;
    widgets!: UpdateDashboardWidgetRequest[];
    sharedWithOrganisationIds!: string[];

    constructor(data?: IUpdateDashboardRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.widgets = [];
            this.sharedWithOrganisationIds = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.title = _data["title"];
            this.enabledInAdmin = _data["enabledInAdmin"];
            this.enabledInOneCare = _data["enabledInOneCare"];
            if (Array.isArray(_data["widgets"])) {
                this.widgets = [] as any;
                for (let item of _data["widgets"])
                    this.widgets!.push(UpdateDashboardWidgetRequest.fromJS(item));
            }
            if (Array.isArray(_data["sharedWithOrganisationIds"])) {
                this.sharedWithOrganisationIds = [] as any;
                for (let item of _data["sharedWithOrganisationIds"])
                    this.sharedWithOrganisationIds!.push(item);
            }
        }
    }

    static fromJS(data: any): UpdateDashboardRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateDashboardRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["enabledInAdmin"] = this.enabledInAdmin;
        data["enabledInOneCare"] = this.enabledInOneCare;
        if (Array.isArray(this.widgets)) {
            data["widgets"] = [];
            for (let item of this.widgets)
                data["widgets"].push(item.toJSON());
        }
        if (Array.isArray(this.sharedWithOrganisationIds)) {
            data["sharedWithOrganisationIds"] = [];
            for (let item of this.sharedWithOrganisationIds)
                data["sharedWithOrganisationIds"].push(item);
        }
        return data; 
    }
}

export interface IUpdateDashboardRequest {
    title: string;
    enabledInAdmin: boolean;
    enabledInOneCare: boolean;
    widgets: UpdateDashboardWidgetRequest[];
    sharedWithOrganisationIds: string[];
}

export class UpdateDashboardWidgetRequest implements IUpdateDashboardWidgetRequest {
    id!: string;
    enabledInOnecare!: boolean;
    enabledInAdmin!: boolean;
    title!: string;
    order!: number;

    constructor(data?: IUpdateDashboardWidgetRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.enabledInOnecare = _data["enabledInOnecare"];
            this.enabledInAdmin = _data["enabledInAdmin"];
            this.title = _data["title"];
            this.order = _data["order"];
        }
    }

    static fromJS(data: any): UpdateDashboardWidgetRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateDashboardWidgetRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["enabledInOnecare"] = this.enabledInOnecare;
        data["enabledInAdmin"] = this.enabledInAdmin;
        data["title"] = this.title;
        data["order"] = this.order;
        return data; 
    }
}

export interface IUpdateDashboardWidgetRequest {
    id: string;
    enabledInOnecare: boolean;
    enabledInAdmin: boolean;
    title: string;
    order: number;
}

export class UpdateDashboardsOrderRequest implements IUpdateDashboardsOrderRequest {
    ownerId!: string;
    dashboardOrders!: DashboardOrder[];

    constructor(data?: IUpdateDashboardsOrderRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.dashboardOrders = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ownerId = _data["ownerId"];
            if (Array.isArray(_data["dashboardOrders"])) {
                this.dashboardOrders = [] as any;
                for (let item of _data["dashboardOrders"])
                    this.dashboardOrders!.push(DashboardOrder.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdateDashboardsOrderRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateDashboardsOrderRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ownerId"] = this.ownerId;
        if (Array.isArray(this.dashboardOrders)) {
            data["dashboardOrders"] = [];
            for (let item of this.dashboardOrders)
                data["dashboardOrders"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IUpdateDashboardsOrderRequest {
    ownerId: string;
    dashboardOrders: DashboardOrder[];
}

export class DashboardOrder implements IDashboardOrder {
    dashboardId!: string;
    order!: number;

    constructor(data?: IDashboardOrder) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dashboardId = _data["dashboardId"];
            this.order = _data["order"];
        }
    }

    static fromJS(data: any): DashboardOrder {
        data = typeof data === 'object' ? data : {};
        let result = new DashboardOrder();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dashboardId"] = this.dashboardId;
        data["order"] = this.order;
        return data; 
    }
}

export interface IDashboardOrder {
    dashboardId: string;
    order: number;
}

export class WidgetCreatedIdResponse implements IWidgetCreatedIdResponse {
    id!: string;

    constructor(data?: IWidgetCreatedIdResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): WidgetCreatedIdResponse {
        data = typeof data === 'object' ? data : {};
        let result = new WidgetCreatedIdResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data; 
    }
}

export interface IWidgetCreatedIdResponse {
    id: string;
}

export class CreateWidgetRequest implements ICreateWidgetRequest {
    title!: string;
    dataSource!: DataSource;
    filter!: FilterRequest;
    displayProperties!: WidgetDisplayPropertyRequest[];

    constructor(data?: ICreateWidgetRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.displayProperties = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.title = _data["title"];
            this.dataSource = _data["dataSource"];
            this.filter = _data["filter"] ? FilterRequest.fromJS(_data["filter"]) : <any>undefined;
            if (Array.isArray(_data["displayProperties"])) {
                this.displayProperties = [] as any;
                for (let item of _data["displayProperties"])
                    this.displayProperties!.push(WidgetDisplayPropertyRequest.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateWidgetRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateWidgetRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["dataSource"] = this.dataSource;
        data["filter"] = this.filter ? this.filter.toJSON() : <any>undefined;
        if (Array.isArray(this.displayProperties)) {
            data["displayProperties"] = [];
            for (let item of this.displayProperties)
                data["displayProperties"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ICreateWidgetRequest {
    title: string;
    dataSource: DataSource;
    filter: FilterRequest;
    displayProperties: WidgetDisplayPropertyRequest[];
}

export class ApiException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}